import { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { updateProjectsStagesStatus, IProjectStage, ISortProject, handleUpdateCurrentActiveStepApi, Stagestep, CurrentStageStep, findPrevStep, findStepIndex, findNextStep } from '../../../modules/project'
import { Field, Form, Formik, FormikProps, getIn, setIn } from 'formik'
import { isEqual } from 'lodash'
import { KTIcon } from '../../../../_theme/helpers'
import NotFound from '../../apps/components/NotFound'
import { useSnackbar } from '../../../../_theme/context/SnackbarContext'
import { ApiResponse, IDocumentData, } from '../../core/_models'
import { useNavigate } from 'react-router-dom'
import { getProjectStageLink, stageCompletedCode } from '../../../../utils/config'
import SubmitConfirmationModal from '../../apps/components/SubmitConfirmationModal'
import StepChangeAlertModal from '../../apps/components/StepChangeAlertModal'
import {
    FileText,
    Send,
    CircleDot,
    CheckCircle,
    DollarSign,
    BarChart,
    Shield,
    Leaf,
    Zap,
    FileCheck,
    Users,
    ListTodo,
    TrendingUp,
    Layers,
} from "lucide-react";
import DynamicSymbol from '../../apps/components/DynamicSymbol'
import ThemeTooltip from '../../apps/components/UI/ThemeTooltip'
import { STEP_TAB_IDS, STEP_TAB_SECTIONS, IConceptAndViabilityStepTypes, IFinalFeasibilityValidation, ILongTermAssetManagement, IESGFinalCheck, IFiscalSustainabilityIfsa, ICostBenefitFinalModel, IEconomicAndCommercialViability, IImplementationStrategy, IEconomicMultiplierAndMacroeconomicsBenefits, ISupervisionReportingAndEvaluation, IDigitalTechnologyLeverage, IInstitutionalAndOperationalReadiness, IProjectCommunicationAndStakeholderEngagementPlan, IFinacialRequirmentsAndFundingstrategy, IRiskStatement, IInfrastructureMasterPlan, ISummaryOfOptionConsidered } from '../components/ConceptAndViability-steps/core/_models'
import { conceptAndViabilityStageSchema, findIncompleteStepTab, IConceptAndViabilityStageSchema, stepTabSchemas } from '../components/ConceptAndViability-steps/core/_validation'
import StepIconSidebar from './StepIconSidebar'
import { conceptAndViabilityDefaultValues } from '../components/ConceptAndViability-steps/core/defaultValues'
import { updateFinalFeasibilityValidation, updateLongTermAssetManagement, updateESGFinalCheck, saveProjectStageFour, updateFiscalSustainabilityIfsaData, updateCostBenefitFinalModel, updateEconomicAndCommercialViability, updateImplementationStrategy, updateEconomicMultiplierAndMacroeconomicsBenefits, updateSupervisionReportingAndEvaluation, updateDigitalTechnologyLeverage, updateInstitutionalAndOperationalReadiness, updateProjectCommunicationAndStakeholderEngagementPlan, updateFinancialRequirementsAndFundingStrategy, updateRiskStatement, updateInfrastructureMasterPlan, updateSummaryOfOptionConsidered } from '../components/ConceptAndViability-steps/core/_request'
import { updateProjectDocuments } from '../core/document/_request'
import { savedFieldValues } from '../core/project-fields/_request'
import AIAssistantSidebar from './AIAssistantSidebar'
import { LogError } from '../../../../utils/GlobalLogging'


const SubmitStep = lazy(() => import('../components/common/SubmitStep').then(module => ({ default: module.SubmitStep })));
import { getApiErrorMessage } from "../../../../utils/utils";
const FinalFeasibilityValidation = lazy(() => import('../components/ConceptAndViability-steps/FinalFeasibilityValidation').then(module => ({ default: module.FinalFeasibilityValidation })));
const CostBenefitFinalModel = lazy(() => import('../components/ConceptAndViability-steps/CostBenefitFinalModel').then(module => ({ default: module.CostBenefitFinalModel })));
const FiscalSustainabilityIfsa = lazy(() => import('../components/ConceptAndViability-steps/FiscalSustainabilityIfsa').then(module => ({ default: module.FiscalSustainabilityIfsa })));
const LongTermAssetManagement = lazy(() => import('../components/ConceptAndViability-steps/LongTermAssetManagement').then(module => ({ default: module.LongTermAssetManagement })));
const ESGFinalCheck = lazy(() => import('../components/ConceptAndViability-steps/ESGFinalCheck').then(module => ({ default: module.ESGFinalCheck })));
const InfrastructureMasterPlan = lazy(() => import('../components/ConceptAndViability-steps/InfrastructureMasterPlan').then(module => ({ default: module.InfrastructureMasterPlan })));
const FinalInvestmentDecisionEngineCoreOutput = lazy(() => import('../components/ConceptAndViability-steps/FinalInvestmentDecisionEngineCoreOutput').then(module => ({ default: module.FinalInvestmentDecisionEngineCoreOutput })));
const ProjectCommunicationAndStakeholderEngagementPlan = lazy(() => import('../components/ConceptAndViability-steps/ProjectCommunicationAndStakeholderEngagementPlan').then(module => ({ default: module.ProjectCommunicationAndStakeholderEngagementPlan })));
const SupervisionReportingAndEvaluation = lazy(() => import('../components/ConceptAndViability-steps/SupervisionReportingAndEvaluation').then(module => ({ default: module.SupervisionReportingAndEvaluation })));
const DigitalTechnologyLeverage = lazy(() => import('../components/ConceptAndViability-steps/DigitalTechnologyLeverage').then(module => ({ default: module.DigitalTechnologyLeverage })));
const InstitutionalAndOperationalReadiness = lazy(() => import('../components/ConceptAndViability-steps/InstitutionalAndOperationalReadiness').then(module => ({ default: module.InstitutionalAndOperationalReadiness })));
const EconomicAndCommercialViability = lazy(() => import('../components/ConceptAndViability-steps/EconomicAndCommercialViability').then(module => ({ default: module.EconomicAndCommercialViability })));
const ImplementationStrategy = lazy(() => import('../components/ConceptAndViability-steps/ImplementationStrategy').then(module => ({ default: module.ImplementationStrategy })));
const EconomicMultiplierAndMacroeconomicsBenefits = lazy(() => import('../components/ConceptAndViability-steps/EconomicMultiplierAndMacroeconomicsBenefits').then(module => ({ default: module.EconomicMultiplierAndMacroeconomicsBenefits })));
const Documents = lazy(() => import('../components/common/DocumentStep').then(module => ({ default: module.DocumentStep })));
const ProjectPlan = lazy(() => import('../components/ConceptAndViability-steps/ProjectPlan/index').then(module => ({ default: module.ProjectPlan })));
const RiskStatement = lazy(() => import('../components/ConceptAndViability-steps/RiskStatement').then(module => ({ default: module.RiskStatement })));
const FinacialRequirmentsAndFundingstrategy = lazy(() => import('../components/ConceptAndViability-steps/FinacialRequirmentsAndFundingstrategy').then(module => ({ default: module.FinacialRequirmentsAndFundingstrategy })));
const SummaryOfOptionConsidered = lazy(() => import("../components/ConceptAndViability-steps/SummaryOfOptionConsidered").then(module => ({ default: module.SummaryOfOptionConsidered })));

type Props = {
    project: ISortProject;
    stage: IProjectStage;
    isApprover: boolean;
    readonlyAccess: boolean;
    canSubmit: boolean;
    user_id: string;
}

const READ_ONLY_STATUSES = ["stage_status_3", "stage_status_4", "stage_status_6"];
const FIRST_STEP_TAB = 1;

const baseStepperData: Stagestep[] = [
    {
        title: "Final Feasibility Validation",
        key: "final_feasibility_validation",
        icon: <CheckCircle size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: FinalFeasibilityValidation,
        showIndex: false,
    },
    {
        title: "Cost-Benefit / Cost-Effectiveness Final Model",
        key: "cost_benefit_final_model",
        icon: <DollarSign size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        components: CostBenefitFinalModel,
        showIndex: false,
    },
    {
        title: "Fiscal Sustainability — IFISA Module",
        key: "fiscal_sustainability_ifsa",
        icon: <BarChart size={22} />,
        iconColor: "text-danger",
        iconBackground: "bg-light-danger",
        components: FiscalSustainabilityIfsa,
        showIndex: false,
    },
    {
        title: "Financial Requirements & Funding Strategy",
        key: "financial_requirements_and_funding_strategy",
        icon: <DollarSign size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        components: FinacialRequirmentsAndFundingstrategy,
        showIndex: false,
    },
    {
        title: "Long-term Asset Management: Financial Analysis and Implications",
        key: "long_term_asset_management",
        icon: <TrendingUp size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        components: LongTermAssetManagement,
        showIndex: false,
    },
    {
        title: "Social, Environmental & Gender Impact Final Check",
        key: "esg_final_check",
        icon: <Leaf size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: ESGFinalCheck,
        showIndex: false,
    },
    {
        title: "Infrastructure Master Plan (Technical Blueprint & SIPDM Architecture)",
        key: "infrastructure_master_plan",
        icon: <FileText size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: InfrastructureMasterPlan,
        showIndex: false,
    },
    {
        title: "Supervision, Reporting & Evaluation",
        key: "supervision_reporting_and_evaluation",
        icon: <FileCheck size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: SupervisionReportingAndEvaluation,
        showIndex: false,
    },
    {
        title: "Project Plan",
        key: "project_plan",
        icon: <ListTodo size={22} />,
        iconColor: "text-info",
        iconBackground: "bg-light-info",
        components: ProjectPlan,
        showIndex: false,
        showContinue: true,
    },
    {
        title: "Project Communication & Stakeholder Engagement Plan",
        key: "project_communication_and_stakeholder_engagement_plan",
        icon: <Users size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: ProjectCommunicationAndStakeholderEngagementPlan,
        showIndex: false,
    },
    {
        title: "Digital Technology Leverage",
        key: "digital_technology_leverage",
        icon: <Zap size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: DigitalTechnologyLeverage,
        showIndex: false,
    },
    {
        title: "Institutional & Operational Readiness",
        key: "institutional_and_operational_readiness",
        icon: <CheckCircle size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: InstitutionalAndOperationalReadiness,
        showIndex: false,
    },
    {
        title: "Economic Multipliers & Macroeconomic Benefits",
        key: "economic_multiplier_and_macroeconomics_benefits",
        icon: <CheckCircle size={22} />,
        iconColor: "text-success",
        iconBackground: "bg-light-success",
        components: EconomicMultiplierAndMacroeconomicsBenefits,
        showIndex: false,
    },
    {
        title: "Implementation Strategy",
        key: "implementation_strategy",
        icon: <FileText size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: ImplementationStrategy,
        showIndex: false,
    },
    {
        title: "Summary of Options Considered",
        key: "summary_of_option_considered",
        icon: <Layers size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        components: SummaryOfOptionConsidered,
        showIndex: false,
    },
    {
        title: "Economic & Commercial Viability — Financial Feasibility Analysis",
        key: "economic_and_commercial_viability",
        icon: <DollarSign size={22} />,
        iconColor: "text-warning",
        iconBackground: "bg-light-warning",
        components: EconomicAndCommercialViability,
        showIndex: false,
    },
    {
        title: "Risk Statement (Problem Justification) & Sensitivity Analysis",
        key: "risk_statement",
        icon: <Shield size={22} />,
        iconColor: "text-danger",
        iconBackground: "bg-light-danger",
        components: RiskStatement,
        showIndex: false,
    },
    {
        title: "Documents",
        key: "documents",
        icon: <FileText size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: Documents,
        showIndex: false,
    },
    {
        title: "Final Investment Decision Engine — Core Output",
        key: "final_investment_decision_engine_core_output",
        icon: <Zap size={22} />,
        iconColor: "text-primary",
        iconBackground: "bg-light-primary",
        components: FinalInvestmentDecisionEngineCoreOutput,
        showIndex: false,
        showContinue: true,
    },
];

const ConceptAndViability: React.FC<Props> = ({ user_id, project, stage, isApprover, readonlyAccess, canSubmit }) => {
    const project_id = project.project_id;

    const stepperData: Stagestep[] = useMemo(() => {
        return [
            ...baseStepperData,
            {
                title: stage.send_to_approval === "yes"
                    ? "Approval"
                    : "Submit",
                key: "approval_submit",
                showIndex: false,
                icon: <Send size={22} />,
                iconColor: "text-primary",
                iconBackground: "bg-primary-light",
                description:
                    stage.send_to_approval === "yes"
                        ? "Submit the project for approval"
                        : "Submit the project",
                components: SubmitStep
            }
        ];
    }, [stage.send_to_approval]);

    const { showSnackbar } = useSnackbar();

    const navigate = useNavigate();
    const [disableFormFields, setDisableFormFields] = useState<boolean>(false);
    const [submitLoader, setSubmitLoader] = useState<boolean>(false);

    const [currentSchema, setCurrentSchema] = useState(conceptAndViabilityStageSchema[stepperData[0].key as IConceptAndViabilityStageSchema]);
    const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useState(false);
    const [stepChangeAlertModal, setStepChnageAlertModal] = useState(false)
    const [pendingStep, setPendingStep] = useState<string | null>(null);
    // A tab switch waiting on the unsaved-changes prompt.
    const [pendingTabChange, setPendingTabChange] = useState<{ tabId: number } | null>(null);

    const [initValues, setInitValues] = useState<IConceptAndViabilityStepTypes>(conceptAndViabilityDefaultValues.final_feasibility_validation);
    const formikRef = useRef<FormikProps<IConceptAndViabilityStepTypes>>(null);
    const [validateOnStepChange, setValidateOnStepChange] = useState(false);
    const [currentStep, setCurrentStep] = useState<CurrentStageStep>(() => {
        const stored = stage.active_step ? stage.active_step.toString() : null;
        return findStepIndex(stepperData, stored !== null ? stored : "project_overview", true);
    });

    const [isAllowNextStep, setIsAllowNextStep] = useState(true);

    // The open tab of a tabbed step (STEP_TAB_IDS), kept with the step it was opened on, so a
    // newly opened step starts on its first tab.
    const [openTab, setOpenTab] = useState<{ step: CurrentStageStep; tabId: number }>(
        () => ({ step: currentStep, tabId: FIRST_STEP_TAB })
    );
    const stepTab = openTab.step === currentStep ? openTab.tabId : FIRST_STEP_TAB;
    const setStepTab = useCallback((tabId: number) => {
        setOpenTab({ step: currentStep, tabId });
    }, [currentStep]);

    // A step that saves one tab at a time validates only the open tab.
    const validationSchema = useMemo(
        () => stepTabSchemas[currentStep.step.key]?.[stepTab] ?? currentSchema,
        [currentStep.step.key, stepTab, currentSchema]
    );

    const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

    useEffect(() => {
        setCurrentSchema(
            conceptAndViabilityStageSchema[currentStep.step.key as IConceptAndViabilityStageSchema]
        );
        setInitValues(
            conceptAndViabilityDefaultValues[
            currentStep.step.key as IConceptAndViabilityStageSchema
            ] as IConceptAndViabilityStepTypes
        );
        setIsAllowNextStep(currentStep.step?.isAllowNextStep === false ? false : true);
    }, [currentStep]);

    useEffect(() => {
        setDisableFormFields(isApprover || readonlyAccess || READ_ONLY_STATUSES.includes(stage.dk_stage_status));
    }, [isApprover, readonlyAccess, stage])

    //  Fixed handleUpdateActiveStep with useCallback
    const handleUpdateActiveStep = useCallback(async (activeStep: string) => {
        const response = await handleUpdateCurrentActiveStepApi(stage.dk_stage, activeStep, Number(project_id));
        if (response.status !== "ok") {
            showSnackbar(response.message, 'danger');
        }
    }, [stage.dk_stage, project_id, showSnackbar]);

    // Save from the "data will be lost" prompt: submits the form, so the step is validated
    // first, and opens the other step only once the save succeeded. A failed save (e.g. a 422)
    // stays on this step with its edits.
    const handleSaveAndContinue = useCallback(async (): Promise<void> => {
        const formik = formikRef.current;
        const target = pendingStep;
        if (!formik || !target) return;

        await formik.setFieldValue("formAction", "save", false);
        // Typed as void, but resolves to submitStep's result, or undefined when validation fails.
        const saved: unknown = await formik.submitForm();
        setStepChnageAlertModal(false);
        setPendingStep(null);
        if (saved === true) {
            setCurrentStep(findStepIndex(stepperData, target));
        }
    }, [pendingStep, stepperData]);

    //  Fixed confirmStepChange
    const confirmStepChange = useCallback(() => {
        if (pendingStep) {
            setCurrentStep(findStepIndex(stepperData, pendingStep));
            setPendingStep(null);
        }
        setStepChnageAlertModal(false);
    }, [pendingStep, stepperData]);

    //  Fixed submitStep with useCallback
    // Resolves to true when the step saved.
    const submitStep = useCallback(async (values: IConceptAndViabilityStepTypes): Promise<boolean> => {
        if (isApprover) return false;

        setSubmitLoader(true);

        try {
            const projectId = Number(project_id);

            const handlers: Record<
                string,
                () => Promise<ApiResponse>
            > = {
                final_feasibility_validation: async () => updateFinalFeasibilityValidation(projectId, values as IFinalFeasibilityValidation),
                fiscal_sustainability_ifsa: async () => updateFiscalSustainabilityIfsaData(projectId, values as IFiscalSustainabilityIfsa),
                cost_benefit_final_model: async () => updateCostBenefitFinalModel(projectId, values as ICostBenefitFinalModel),
                // Its risk rows save on the risk-management API as they are added.
                long_term_asset_management: async () => updateLongTermAssetManagement({ ...(values as ILongTermAssetManagement), project_id: projectId }),
                esg_final_check: async () => updateESGFinalCheck({ ...(values as IESGFinalCheck), project_id: projectId }, stepTab),
                economic_and_commercial_viability: async () => updateEconomicAndCommercialViability({ ...(values as IEconomicAndCommercialViability), project_id: projectId }),
                implementation_strategy: async () => updateImplementationStrategy({ ...(values as IImplementationStrategy), project_id: projectId }),
                economic_multiplier_and_macroeconomics_benefits: async () => updateEconomicMultiplierAndMacroeconomicsBenefits({ ...(values as IEconomicMultiplierAndMacroeconomicsBenefits), project_id: projectId }),
                documents: async () => updateProjectDocuments({ documents: (values as IDocumentData).documents, project_id: projectId, stage_id: stage.dk_stage }),
                final_investment_decision_engine_core_output: async () => ({ status: "ok", message: "Final Investment Decision Engine Core Output saved", data: null }),
                supervision_reporting_and_evaluation: async () => updateSupervisionReportingAndEvaluation({ ...(values as ISupervisionReportingAndEvaluation), project_id: projectId }),
                infrastructure_master_plan: async () => updateInfrastructureMasterPlan({ ...(values as IInfrastructureMasterPlan), project_id: projectId }),
                digital_technology_leverage: async () => updateDigitalTechnologyLeverage({ ...(values as IDigitalTechnologyLeverage), project_id: projectId }),
                institutional_and_operational_readiness: async () => updateInstitutionalAndOperationalReadiness({ ...(values as IInstitutionalAndOperationalReadiness), project_id: projectId }, stepTab),
                project_communication_and_stakeholder_engagement_plan: async () => updateProjectCommunicationAndStakeholderEngagementPlan({ ...(values as IProjectCommunicationAndStakeholderEngagementPlan), project_id: projectId }, stepTab),
                financial_requirements_and_funding_strategy: async () => updateFinancialRequirementsAndFundingStrategy({ ...(values as IFinacialRequirmentsAndFundingstrategy), project_id: projectId }),
                risk_statement: async () => updateRiskStatement({ ...(values as IRiskStatement), project_id: projectId }),
                summary_of_option_considered: async () => updateSummaryOfOptionConsidered({ ...(values as ISummaryOfOptionConsidered), project_id: projectId }, stepTab),
            };

            const handler = handlers[currentStep.step.key];

            const response: ApiResponse = handler
                ? await handler()
                : {
                    status: "error",
                    message: "Something went wrong",
                    data: null,
                };

            if (response.status === "ok") {
                showSnackbar(response.message, "success");

                // The API returns null for every empty field. Those keep the form's value, as on load:
                // a null breaks Yup.string() on the next save and counts as filled in the IFISA gauge.
                const savedData = response.data ? savedFieldValues<IConceptAndViabilityStepTypes>(response.data) : null;

                let activeStep = currentStep.step.key;

                const stepTabIds = STEP_TAB_IDS[currentStep.step.key];
                const nextTabId = stepTabIds?.[stepTabIds.indexOf(stepTab) + 1];

                if (values.formAction === "save-next" && nextTabId !== undefined) {
                    // Save & Next on a tabbed step opens its next tab; the last tab moves on.
                    setStepTab(nextTabId);
                    if (savedData) {
                        formikRef.current?.resetForm({ values: { ...values, ...savedData, formAction: "" } as IConceptAndViabilityStepTypes });
                    }
                } else if (values.formAction === "save-next") {
                    // A step that validates one tab at a time is left from its last tab only once
                    // every tab is complete; otherwise the first incomplete tab opens with its errors.
                    const incomplete = stepTabSchemas[currentStep.step.key]
                        ? await findIncompleteStepTab(currentStep.step.key, values)
                        : null;
                    if (incomplete) {
                        const formik = formikRef.current;
                        setStepTab(incomplete.tabId);
                        formik?.setErrors(incomplete.errors);
                        void formik?.setTouched(
                            Object.keys(incomplete.errors).reduce((acc, key) => setIn(acc, key, true), {}),
                            false,
                        );
                        showSnackbar(`Complete ${incomplete.title} before continuing.`, "warning");
                    } else {
                        const nextStep = findNextStep(currentStep, stepperData);
                        activeStep = nextStep.step.key;
                        setCurrentStep(nextStep);
                    }
                } else if (savedData) {
                    // The response is merged into the form: a tabbed step's may hold only the saved tab,
                    // and the null fields dropped above must keep the form's values.
                    formikRef.current?.resetForm({
                        values: { ...values, ...savedData, formAction: "" } as IConceptAndViabilityStepTypes,
                    });
                }

                if (stage.active_step !== activeStep) {
                    handleUpdateActiveStep(activeStep);
                }
                return true;
            }
            showSnackbar(response.message, "danger");
            return false;
        } catch (error) {
            showSnackbar(getApiErrorMessage(error, "Something went wrong"), "danger");
            return false;
        } finally {
            setSubmitLoader(false);
        }
    }, [isApprover, project_id, currentStep, stepTab, setStepTab, stepperData, stage.active_step, showSnackbar, handleUpdateActiveStep]);

    // The fields the open tab's Save covers: its own on a step that saves one tab at a time,
    // otherwise every field of the step.
    const tabSaveFields = useCallback((values: object): readonly string[] => {
        const tabSections = STEP_TAB_SECTIONS[currentStep.step.key];
        if (tabSections) return tabSections[stepTab]?.fields ?? [];
        return Object.keys(values).filter((field) => field !== "formAction");
    }, [currentStep.step.key, stepTab]);

    // Switching tabs asks first when there are unsaved edits.
    const changeStepTab = useCallback((tabId: number) => {
        if (tabId === stepTab) return;
        const formik = formikRef.current;
        const hasUnsavedEdits = !!formik && !disableFormFields && tabSaveFields(formik.values).some(
            (field) => !isEqual(getIn(formik.values, field), getIn(formik.initialValues, field))
        );
        if (hasUnsavedEdits) {
            setPendingTabChange({ tabId });
            return;
        }
        setStepTab(tabId);
    }, [stepTab, setStepTab, tabSaveFields, disableFormFields]);

    // Continue without saving: put the unsaved fields back to their saved values, then switch.
    const discardAndChangeTab = useCallback(() => {
        const formik = formikRef.current;
        if (formik && pendingTabChange) {
            let restored = formik.values;
            tabSaveFields(formik.values).forEach((field) => {
                restored = setIn(restored, field, getIn(formik.initialValues, field));
            });
            void formik.setValues(restored, false);
            formik.setErrors({});
            setStepTab(pendingTabChange.tabId);
        }
        setPendingTabChange(null);
    }, [tabSaveFields, pendingTabChange, setStepTab]);

    // Save & Continue: save (with validation), and switch only if it saved.
    const saveAndChangeTab = useCallback(async () => {
        const formik = formikRef.current;
        const target = pendingTabChange;
        if (!formik || !target) return;

        await formik.setFieldValue("formAction", "save", false);
        // Typed as void, but resolves to submitStep's result, or undefined when validation fails.
        const saved: unknown = await formik.submitForm();
        setPendingTabChange(null);
        if (saved === true) {
            setStepTab(target.tabId);
        }
    }, [pendingTabChange, setStepTab]);

    //  Fixed handleSubmitStage
    const handleSubmitStage = useCallback(async () => {
        // find first incomplete step
        // TODO: Implement this later
        /*const incompleteIndex = stepInits.findIndex(
            step => !step.iscompleted
        );
        if (incompleteIndex !== -1 && incompleteIndex != stepInits.length - 1) {
            const targetStep = incompleteIndex + 1;
            // move to that step
            setCurrentStep(findStepIndex(stepperData, stepperData[targetStep].key));
            setValidateOnStepChange(true);
            return;
        }*/

        setShowSubmitConfirmationModal(true);
    }, []);

    //  Fixed validation useEffect with cleanup
    useEffect(() => {
        if (!validateOnStepChange) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if (formikRef.current) {
                formikRef.current.validateForm().then(errors => {
                    const touchedFields = Object.keys(errors).reduce(
                        (acc, key) => {
                            return setIn(acc, key, true);
                        },
                        {}
                    );
                    formikRef.current?.setTouched(touchedFields);
                });
            }
        }, 100);

        setValidateOnStepChange(false);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [initValues, validateOnStepChange]);

    //  Fixed handleConfirmSubmitStage
    const handleConfirmSubmitStage = useCallback(async () => {
        setSubmitLoader(true);
        const data = {
            project_id: project_id,
            dk_stage: stage.dk_stage,
        }

        try {
            const stageSubmitResp = await saveProjectStageFour(data);
            if (stageSubmitResp.status === "ok") {
                // if (stage.send_to_approval === "no") {
                //     const data = {
                //         user_id: user_id,
                //         project_id: project_id,
                //         dk_stage: stage.dk_stage
                //     }
                //     await getProjectReport(data, stage.dk_stage);
                // }
                showSnackbar(stageSubmitResp.message, 'success');
                navigate(getProjectStageLink(project_id));
            } else {
                showSnackbar(stageSubmitResp.message || 'Failed to submit stage', 'danger');
            }
        } catch (error) {
            // The submit API rejects a blocked stage (422) with a message listing what blocks it.
            showSnackbar(getApiErrorMessage(error, "Failed to submit stage"), 'danger');
            LogError("Failed to submit stage", error, "ConceptAndViability");
        } finally {
            setSubmitLoader(false);
            setShowSubmitConfirmationModal(false);
        }
    }, [user_id, project_id, stage.dk_stage, stage.send_to_approval, navigate, showSnackbar]);

    //  Fixed prevStep
    const prevStep = useCallback((dirty: boolean) => {
        const prev = findPrevStep(currentStep, stepperData);
        if (!["stage_status_3", "stage_status_4", "stage_status_6"].includes(stage.dk_stage_status) && dirty) {
            setPendingStep(prev.step.key);
            setStepChnageAlertModal(true);
            return;
        }
        setCurrentStep(prev)
    }, [currentStep, stepperData, stage.dk_stage_status]);

    const handleContinue = useCallback(() => {
        // A tabbed step opens its next tab; the last tab moves on.
        const stepTabIds = STEP_TAB_IDS[currentStep.step.key];
        const nextTabId = stepTabIds?.[stepTabIds.indexOf(stepTab) + 1];
        if (nextTabId !== undefined) {
            setStepTab(nextTabId);
            return;
        }
        const nextStep = findNextStep(currentStep, stepperData);
        setCurrentStep(nextStep);
        handleUpdateActiveStep(nextStep.step.key);
    }, [currentStep, stepperData, handleUpdateActiveStep, stepTab, setStepTab]);

    //  Fixed goToStep
    const goToStep = useCallback((key: string, dirty: boolean) => {
        if (!["stage_status_3", "stage_status_4", "stage_status_6"].includes(stage.dk_stage_status) && dirty) {
            setPendingStep(key);
            setStepChnageAlertModal(true);
            return;
        }
        setCurrentStep(findStepIndex(stepperData, key))
    }, [stepperData, stage.dk_stage_status]);

    //  Fixed handleProjectRequestSubmit (THIS WAS MISSING)
    const handleProjectRequestSubmit = useCallback(async (stageStatus: string, remarks: string) => {
        setSubmitLoader(true);
        const data = {
            user_id: user_id,
            project_id: project_id,
            dk_stage: stage.dk_stage,
            project_stage_id: stage.project_stage_id,
            action: stageStatus,
            remarks: remarks
        }

        let stageSubmitResp: any = await updateProjectsStagesStatus(data);
        if (stageSubmitResp.status === "ok") {
            showSnackbar(stageSubmitResp.message, 'success');
            if (stageStatus == stageCompletedCode) {
                const data = {
                    user_id: user_id,
                    project_id: project_id,
                    dk_stage: stage.dk_stage
                }
                // await getProjectReport(data, stage.dk_stage);
                navigate(`/dashboard`);
            } else {
                navigate(`/dashboard`);
            }
        } else {
            setSubmitLoader(false);
            showSnackbar(stageSubmitResp.message, 'danger');
        }
    }, [user_id, project_id, stage.dk_stage, stage.project_stage_id, navigate, showSnackbar]);

    //  Fixed loadSteppter
    const loadSteppter = useCallback(() => {
        const CurrentStepComponent = currentStep.step.components;
        const StepComponent = CurrentStepComponent as React.ComponentType<{
            submitLoader: boolean;
            project_id: string;
            disableFormFields: boolean;
            setInitValues: React.Dispatch<React.SetStateAction<IConceptAndViabilityStepTypes>>;
            isApprover: boolean;
            stage: IProjectStage;
            handleProjectRequestSubmit: (stageStatus: string, remarks: string) => void,
            setIsAllowNextStep: React.Dispatch<React.SetStateAction<boolean>>
            stepTab: number;
            setStepTab: (tabId: number) => void;
        }>;

        return (
            <Suspense fallback={<div className="p-4 text-center">Loading step...</div>}>
                <StepComponent
                    submitLoader={submitLoader}
                    project_id={project_id}
                    disableFormFields={disableFormFields}
                    setInitValues={setInitValues}
                    isApprover={isApprover}
                    stage={stage}
                    handleProjectRequestSubmit={handleProjectRequestSubmit}
                    setIsAllowNextStep={setIsAllowNextStep}
                    stepTab={stepTab}
                    setStepTab={changeStepTab}
                />
            </Suspense>
        );
    }, [currentStep.step.components, submitLoader, project_id, disableFormFields, isApprover, stage, handleProjectRequestSubmit, stepTab, changeStepTab]);

    //  Fixed handleFormSubmit to prevent double submission
    const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>, handleSubmit: any, setFieldValue: any) => {
        e.preventDefault();

        const submitter = (e.nativeEvent as SubmitEvent).submitter as HTMLButtonElement;
        const action = submitter?.value;

        if (action) {
            await setFieldValue("formAction", action);
        }

        // Call handleSubmit directly without calling requestSubmit again
        handleSubmit(e);
    }, []);

    if (!initValues) {
        return <NotFound />;
    }

    return (
        <div
            className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
            style={{ minHeight: '50vh' }}
            id='project_stepper'
        >
            <Formik<IConceptAndViabilityStepTypes> innerRef={formikRef} validationSchema={validationSchema} enableReinitialize={true} initialValues={initValues} onSubmit={submitStep}>
                {({ handleSubmit, setFieldValue, dirty, values }: FormikProps<IConceptAndViabilityStepTypes>) => {
                    return <>
                        {/* begin::Aside*/}
                        <StepIconSidebar
                            steps={stepperData}
                            currentStep={currentStep}
                            onStepClick={(key) => goToStep(key, dirty)}
                        />
                        {/* begin::Aside*/}
                        <div className='d-flex flex-row-fluid justify-content-center bg-body rounded'>
                            <Form className='p-8 w-100 position-relative' noValidate id='kt_create_account_form' onSubmit={(e) => handleFormSubmit(e, handleSubmit, setFieldValue)}>
                                <div className='card card-custom'>
                                    <div className='card-header align-items-center'>
                                        <div className='d-flex align-items-center'>
                                            <DynamicSymbol
                                                size={40}
                                                bgClass={`${currentStep.step.iconColor} ${currentStep.step.iconBackground}`}
                                                icon={currentStep.step.icon ? currentStep.step.icon : <CircleDot size={22} />}
                                            />
                                            <div>
                                                <div className='d-flex align-items-center'>
                                                    <h3 className='card-title align-items-center mb-0 mt-0'>{currentStep.step.title}</h3>
                                                    {currentStep.step.tooltip && <ThemeTooltip text={currentStep.step.tooltip} />}
                                                </div>
                                                {currentStep.step.description && <div className="text-muted fs-7 mt-0">{currentStep.step.description}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body pt-2 px-10 pb-8'>
                                        {loadSteppter()}
                                        {(!disableFormFields || (currentStep.isLast && canSubmit)) &&
                                            <div className='d-flex flex-stack pt-6 pb-0 px-4'>
                                                <div className='mr-2'>{!currentStep.isFirst &&
                                                    <button
                                                        onClick={() => prevStep(dirty)}
                                                        type='button'
                                                        className='btn btn-md btn-light-primary me-3'
                                                    >
                                                        <KTIcon iconName='arrow-left' className='fs-4 me-1' />
                                                        Back
                                                    </button>}
                                                </div>
                                                <div>
                                                    {currentStep.step.showContinue ?
                                                    <> {isAllowNextStep && 
                                                        <button disabled={submitLoader} type='button' className='btn btn-md btn-primary ms-3' onClick={() => handleContinue()}>
                                                            <span className='indicator-label d-flex flex-center'>
                                                                {'Next'}
                                                                <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                                                            </span>
                                                        </button> }
                                                        </>
                                                        : <>
                                                            {!currentStep.isLast ? <>
                                                                <button disabled={submitLoader} type='submit' value='save' className='btn btn-md btn-active-primary btn-color-primary border border-primary btn-active-color-white save-only'>
                                                                    <span className='indicator-label d-flex flex-center'>{submitLoader && values.formAction === "save" ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Saving...</span></> : "Save"}</span>
                                                                </button>
                                                                {isAllowNextStep &&
                                                                    <button disabled={submitLoader} type='submit' value='save-next' className='btn btn-md btn-primary ms-3'>
                                                                        <span className='indicator-label d-flex flex-center'>
                                                                            {submitLoader && values.formAction === "save-next" ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Saving & opening next...</span></> : "Save & Next"}
                                                                            <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                                                                        </span>
                                                                    </button>} </> :
                                                                canSubmit && <button disabled={submitLoader} onClick={handleSubmitStage} type='button' className='btn btn-md btn-primary'>
                                                                    <span className='indicator-label d-flex flex-center'>
                                                                        {submitLoader ? <><span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span><span className='ms-2'>Submitting...</span></> : "Submit"}
                                                                    </span>
                                                                </button>
                                                            }
                                                        </>
                                                    }
                                                    <Field type="hidden" name="formAction" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form>
                            <StepChangeAlertModal
                                popupLoader={submitLoader}
                                show={stepChangeAlertModal}
                                onClose={() => setStepChnageAlertModal(false)}
                                onConfirm={() => confirmStepChange()}
                                onSave={() => void handleSaveAndContinue()}
                                message={`Your updated data in this step will be lost if you move to another step without saving. Do you want to continue?`}
                            />
                            <StepChangeAlertModal
                                title='Tab change Confirmation'
                                popupLoader={submitLoader}
                                show={pendingTabChange !== null}
                                onClose={() => setPendingTabChange(null)}
                                onConfirm={discardAndChangeTab}
                                onSave={() => void saveAndChangeTab()}
                                message={`Your changes in this tab are not saved. Save them before opening another tab, or continue and discard them.`}
                            />
                        </div>
                        <AIAssistantSidebar />
                    </>
                }}
            </Formik>
            <SubmitConfirmationModal
                text="After submitting this stage, you will not be able to make any changes. Are you sure you want to submit this stage?"
                loader={submitLoader}
                show={showSubmitConfirmationModal}
                onClose={() => setShowSubmitConfirmationModal(false)}
                onConfirm={handleConfirmSubmitStage}
            />
        </div>
    )
}

export default ConceptAndViability